module.exports = __webpack_public_path__ + "static/media/case-2.c226fad1.png";